export default __webpack_public_path__ + "static/media/rocket.013cc87e.svg";